import { Link } from "react-router-dom";

export const CustomLink: React.FC<{
  text: string;
  to: string;
  color?: string;
  fontSize?: string;
  tailwindcs?: string;
}> = ({ text, to, color, fontSize, tailwindcs }) => {
  return (
    <div className={tailwindcs}>
      <Link
        className={tailwindcs}
        style={{ color, fontSize }} // Apply fontSize
        to={to}
      >
        {text}
      </Link>
    </div>
  );
};
